import { css } from '@emotion/core';
import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';
import NvTooltip from 'shared/components/nv-tooltip';
import ClickableContainer from 'components/clickable-container';
import { ProgressiveQuizMode } from 'quizzes/components/mode';
import { getAlphabetCharacter } from 'quizzes/components/utils';
import useQuestionSetHelpers from 'quizzes/hooks/use-question-set-helpers';
import { ComponentType } from 'redux/schemas/models/lecture-component';
import { gray3, success, white } from 'styles/global_defaults/colors';
import { largeSpacing } from 'styles/global_defaults/scaffolding';


type BigCheckboxProps = {
  index: number;
  color: string;
  checked: boolean;
  selected: boolean;
  mode: ProgressiveQuizMode;
  onChange: (newChecked) => void;
  className?: string;
  characterClassName?: string,
  optionId: number,
  circularBorder?: boolean,
};

const BigCheckbox = (props: BigCheckboxProps) => {
  const {
    mode,
    index,
    color,
    selected,
    onChange,
    className,
    checked = false,
    characterClassName,
    optionId,
    circularBorder = false,
  } = props;

  const {
    isCurrentActivityType,
    dataQaQuestionSetAttributes,
  } = useQuestionSetHelpers();

  const editNotFocusedBorderColor = checked ? success : gray3;

  const styles = css`
    border-radius: ${circularBorder ? '50%' : '4px'};
    width: ${largeSpacing}px;
    height: ${largeSpacing}px;
    border: 1px solid ${gray3};

    ${mode === ProgressiveQuizMode.EDIT ? css`
      border: 1px solid ${editNotFocusedBorderColor};
    ` : css`
      ${selected && css`
        border: 1px solid ${color};
        background-color: ${white};

        .text-large-body {
          color: ${color};
        }
      `};
    `};
  `;

  return (
    <NvTooltip
      text={t.QUIZZES.MARK_CORRECT_ANSWER()}
      enabled={mode === ProgressiveQuizMode.EDIT && !checked && !isCurrentActivityType(ComponentType.SURVEY)}
    >
      <ClickableContainer
        css={styles}
        onClick={() => onChange(!checked)}
        layoutOnly={mode !== ProgressiveQuizMode.EDIT || isCurrentActivityType(ComponentType.SURVEY)}
        className={`bg-color-gray-7 align-items-center justify-content-center ${className}`}
        data-qa={dataQaQuestionSetAttributes.questionModal.optionCorrectCheckbox}
        data-qa-id={`${dataQaQuestionSetAttributes.questionModal.optionCorrectCheckbox}_${optionId}`}
      >
        {mode === ProgressiveQuizMode.EDIT ? (checked && (
          <NvIcon icon='check' size='smallest' className='d-flex color-success' />
        )) : (
          <div className={`text-large-body font-weight-bolder color-gray-1 ${characterClassName}`}>
            {getAlphabetCharacter(index)}
          </div>
        )}
      </ClickableContainer>
    </NvTooltip>
  );
};

export default BigCheckbox;
